// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import { Observer } from "mobx-vue";
import ModuleWrapper from "../../../components/module_wrapper/ModuleWrapper";
import { getTranslatedImage as getTranslatedImageHelper } from "../../../common/ModuleHelpers";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
  },
})
export class StoryLink extends Vue {
  @Prop({ default: "black" })
  backgroundColor!: string;

  @Prop()
  link!: string;

  @Prop()
  instance!: object;

  @Prop({ default: "" })
  highlightText!: string;

  @Prop()
  lang!: string;

  getTranslatedImage(imageObject, language, size) {
    return getTranslatedImageHelper(imageObject, language, size);
  }
}
